var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar75(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "198px",
    height: "188px",
    viewBox: "0 0 198 188",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "star_75") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parts",
    transform: "translate(-755.000000, -48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star_75",
    transform: "translate(756.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.1132075,140.495552 L39.8081143,179.444626 L58.301418,112.130184 L3.77358491,68.5417479 L73.850201,65.3286185 C90.0255387,22.4282615 98.1132075,0.978082945 98.1132075,0.978082945 C98.1132075,0.978082945 106.918239,23.4993046 124.528302,68.5417479 C124.528302,126.484628 124.528302,155.456068 124.528302,155.456068 C124.528302,155.456068 115.72327,150.469229 98.1132075,140.495552 Z",
    id: "Star-Copy",
    fill: "#FFD21C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-Copy",
    stroke: "#FFD21C",
    strokeWidth: 3.77358491,
    points: "98.1132075 140.495552 40.4437111 178.466543 58.7354152 111.885911 4.80200217 68.772642 73.7763935 65.5945396 98.1132075 0.978082945 122.450022 65.5945396 191.424413 68.772642 137.491 111.885911 155.782704 178.466543"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar75);
export default __webpack_public_path__ + "static/media/star_75.245c2c0c381c9d87fd6eabdfdccc534c.svg";
export { ForwardRef as ReactComponent };